<template>
    <div class="n2-center-container">
        <div id="home-page">
            <app-content name="web.home.main"></app-content>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="n2-padding">
                        <div class="n2-bold">
                            {{ $t('pages.home.travel_from') }}
                        </div>
                        <div style="max-width: 300px; position: relative;">
                            <app-autocomplete v-model="query.origin_id"
                                v-bind:item_css_class="'notranslate'"
                                v-bind:placeholder="$t('pages.home.stop_place_holder')" v-bind:items="stops"
                                v-bind:text_field="'name'" v-bind:separator="' '" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.origin_id">
                            </app-autocomplete>
                            <app-loader v-bind:active="loadingDepartures"></app-loader>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="n2-padding">
                        <div class="n2-bold">
                            {{ $t('pages.home.travel_to') }}
                        </div>
                        <div style="max-width: 300px; position: relative;">
                            <app-autocomplete ref="el_stop_to" v-model="query.destination_id"
                                v-bind:item_css_class="'notranslate'"
                                v-bind:placeholder="$t('pages.home.stop_place_holder')" v-bind:items="destinations"
                                v-bind:text_field="'name'" v-bind:separator="' '" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.destination_id">
                            </app-autocomplete>
                            <app-loader v-bind:active="loadingArrivals"></app-loader>
                        </div>
                    </div>
                </div>
            </div>
            <div class="n2-padding">
                <label class="n2-radio-lable">
                    <input type="radio" class="n2-radio-input" name="radio_roundtrip" v-model="query.roundtrip"
                        value="false" />
                    <span class="n2-radio-text">{{ $t('pages.home.oneway') }}</span>
                </label>
                <label class="n2-radio-lable">
                    <input type="radio" class="n2-radio-input" name="radio_roundtrip" v-model="query.roundtrip"
                        value="true" />
                    <span class="n2-radio-text">{{ $t('pages.home.roundtrip') }}</span>
                </label>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="n2-padding">
                        <div class="n2-bold">
                            {{ $t('pages.home.outward_date') }}
                        </div>
                        <div style="max-width: 300px;">
                            <app-calendar v-model="query.outward_date" v-bind:locale="locale" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.outward_date" v-bind:min_date="iso_today"
                                v-on:selected="loadFares" v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css"
                                v-bind:valid_dates="valid_dates">
                            </app-calendar>
                        </div>
                    </div>
                </div>
                <div v-show="query.roundtrip == 'true'" class="col-12 col-md-6">
                    <div class="n2-padding">
                        <div class="n2-bold">
                            {{ $t('pages.home.backward_date') }}
                        </div>
                        <div style="max-width: 300px;">
                            <app-calendar v-model="query.backward_date" v-bind:locale="locale" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.backward_date" v-bind:min_date="backward_min_date"
                                v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css"
                                v-bind:valid_dates="valid_dates">
                            </app-calendar>
                        </div>
                    </div>
                </div>
            </div>

            <div class="n2-padding" style="position: relative; min-height: 100px;">
                <div class="n2-product-list" v-for="group in product_groups" v-bind:key="group">
                    <div class="product-group-container">
                        <div class="product-group">{{ group.name }}</div>
                    </div>
                    <div class="products-section">
                        <div class="product-container" v-for="product in group.products" v-bind:key="product">
                            <div class="product">
                                <div class="quanitity-selector">
                                    <div class="quanity-btn" v-on:click="changeQuantity(product, -1)"><i
                                            class="fa fa-minus" aria-hidden="true"></i></div>
                                    <input class="product-quantity-field" type="text" autocomplete="new-password"
                                        v-model="product.quantity"
                                        v-on:change="changeQuantity(product, $event.target.value, 'set')" />
                                    <div class="quanity-btn" v-on:click="changeQuantity(product, 1)"><i
                                            class="fa fa-plus" aria-hidden="true"></i></div>
                                </div>
                                <div class="product-name">
                                    <span>{{ product.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="zeroProducts && product_groups.length == 0" style="color: #b94a48">
                    {{ $t('pages.home.error_products_not_found') }}
                </div>
                <app-loader v-bind:active="loadingFares"></app-loader>
            </div>


            <div class="n2-padding">

                <ul class="n2-errors n2-margin-top">
                    <li v-if="validate('origin')">
                        {{ $t('pages.home.error_origin') }}
                    </li>
                    <li v-if="validate('destination')">
                        {{ $t('pages.home.error_destination') }}
                    </li>
                    <li v-if="validate('outward_date')">
                        {{ $t('pages.home.error_outward_date') }}
                    </li>
                    <li v-if="validate('backward_date')">
                        {{ $t('pages.home.error_backward_date') }}
                    </li>
                    <li v-if="validate('travel_money')">
                        {{ $t('pages.home.error_travel_money') }}
                    </li>
                    <li v-if="validate('birthdate')">
                        {{ $t('pages.home.error_birthdate') }}
                    </li>
                    <li v-if="validate('kolumbus_card')">
                        {{ $t('pages.home.error_kolumbus_card') }}
                    </li>
                    <li v-if="validate('products')">
                        {{ $t('pages.home.error_products') }}
                    </li>
                </ul>
            </div>
            <div class="n2-padding n2-text-right">
                <button class="n2-button-1" v-on:click="searchTrips">{{ $t('pages.home.search_trips') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppAutocomplete from '../components/shared/autocomplete.vue';
import AppCalendar from '../components/shared/calendar.vue';
import AppLoader from '../components/shared/loader.vue';
import AppContent from '../components/shared/content.vue';

import { StopService, ProductService, TripService, TicsentService } from '../services'

export default {
    name: 'PageIndex',
    components: {
        AppAutocomplete,
        AppCalendar,
        AppLoader,
        AppContent
    },
    data: function () {
        return {
            model_errors: {},
            query: {
                ticket_mode: 'online_payment',
                origin_id: '',
                destination_id: '',
                outward_date: '',
                backward_date: '',
                backward_calendar_month: '',
                roundtrip: 'false',
            },
            invalid_fields: [],
            loadingDepartures: false,
            loadingArrivals: false,
            loadingFares: false,
            zeroProducts: false,
            valid_dates: null,
            dates_css: [
                { date: '2024-01-01', css: 'holiday' },
                { date: '2024-03-28', css: 'holiday' },
                { date: '2024-03-29', css: 'holiday' },
                { date: '2024-03-31', css: 'holiday' },
                { date: '2024-04-01', css: 'holiday' },
                { date: '2024-05-01', css: 'holiday' },
                { date: '2024-05-17', css: 'holiday' },
                { date: '2024-05-19', css: 'holiday' },
                { date: '2024-05-20', css: 'holiday' },
                { date: '2024-12-25', css: 'holiday' },
                { date: '2024-12-26', css: 'holiday' },
                { date: '2025-01-01', css: 'holiday' },
                { date: '2025-04-17', css: 'holiday' },
                { date: '2025-04-18', css: 'holiday' },
                { date: '2025-04-20', css: 'holiday' },
                { date: '2025-04-21', css: 'holiday' },
                { date: '2025-05-01', css: 'holiday' },
                { date: '2025-05-17', css: 'holiday' },
                { date: '2025-05-29', css: 'holiday' },
                { date: '2025-06-08', css: 'holiday' },
                { date: '2025-06-09', css: 'holiday' },
                { date: '2025-12-25', css: 'holiday' },
                { date: '2025-12-26', css: 'holiday' },
                { date: '2026-01-01', css: 'holiday' },
                { date: '2026-04-02', css: 'holiday' },
                { date: '2026-04-03', css: 'holiday' },
                { date: '2026-04-05', css: 'holiday' },
                { date: '2026-04-06', css: 'holiday' },
                { date: '2026-05-01', css: 'holiday' },
                { date: '2026-05-14', css: 'holiday' },
                { date: '2026-05-17', css: 'holiday' },
                { date: '2026-05-24', css: 'holiday' },
                { date: '2026-05-25', css: 'holiday' },
                { date: '2026-12-25', css: 'holiday' },
                { date: '2026-12-26', css: 'holiday' },
            ]
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
            'language'
        ]),
        ...mapGetters('planner', [
            'stops',
            'destinations',
            'products',
            'search_paras',
            'selected_products'
        ]),
        iso_today: {
            get() {
                let today = new Date();
                return new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())).toISOString().split('T')[0];
            }
        },
        backward_min_date() {
            let d = new Date(this.query.outward_date);
            let today = new Date(this.iso_today);
            return d > today ? this.query.outward_date : this.iso_today;
        },
        product_groups() {
            let selectedProducts = [];
            try {
                selectedProducts = JSON.parse(this.selected_products);
            } catch (error) {
                selectedProducts = [];
            }
            try {
                var groups = this.products.reduce((acc, p) => {
                    var obj = Object.assign({}, p)
                    let key = obj.group.name
                    obj.quantity = 0;

                    var foundProduct = selectedProducts.find(e => e.id == obj.id);
                    if (foundProduct) {
                        obj.quantity = foundProduct.quantity;
                    }

                    var found = acc.find(element => {
                        return element.name === key
                    })
                    if (!found) {
                        acc.push({ name: key, products: [obj] })
                    }
                    else {
                        found.products.push(obj)
                    }
                    return acc
                }, []);

            }
            catch {
                return [];
            }
            return groups;
        }
    },
    watch: {
        'query.origin_id': function () {
            this.nav();
        },
        'query.destination_id': function () {
            this.nav();
        },
        'query.outward_date': function () {
            if (new Date(this.query.outward_date) > new Date(this.query.backward_date)) {
                this.query.backward_date = this.query.outward_date;
            }
            this.nav();
        },
        'query.backward_date': function () {
            this.nav();
        },
        'query.roundtrip': function () {
            this.nav();
        },
        'locale': async function () {
            if (this.query.origin_id && this.query.destination_id && this.query.outward_date) {
                await this.loadFares();
            }
        }
    },
    created: function () {
        this.stopService = new StopService();
        this.productService = new ProductService();
        this.tripService = new TripService();
        this.ticsentService = new TicsentService();
    },
    mounted: async function () {

        Object.assign(this.query, this.$route.query);
        if (!this.query.outward_date) {
            this.query.outward_date = this.iso_today;
        }
        this.handelRoundTrip();

        await this.load();
    },
    beforeRouteUpdate(to, from, next) {
        Object.assign(this.query, to.query);
        if (!this.query.outward_date) {
            let d1 = new Date()
            this.query.outward_date = d1.toISOString().split('T')[0]
        }
        this.handelRoundTrip();
        this.load();
        next();
    },
    methods: {
        handelRoundTrip: function () {
            if (this.query.roundtrip === true) {
                this.query.roundtrip = 'true';
            }
            if (this.query.roundtrip === false) {
                this.query.roundtrip = 'false';
            }
        },
        nav: function () {
            if (JSON.stringify(this.query) !== JSON.stringify(this.$route.query)) {
                this.$router.push({
                    path: '', query: this.query
                });
            }
        },
        load: async function () {
            if (this.stops.length == 0) {
                try {
                    this.loadingDepartures = true;
                    var stopResult = await this.stopService.search({ page_size: 500 });
                    this.$store.commit('planner/set_stops', stopResult.data);
                }
                finally { this.loadingDepartures = false; }
            }
            if (this.query.origin_id) {
                await this.loadDestinations();
                if (this.query.origin_id && !this.query.destination_id) {
                    this.$nextTick(() => this.$refs.el_stop_to.$el.children[0].focus())
                }
            }
            if (this.query.origin_id && this.query.destination_id && this.query.outward_date) {
                await this.loadFares();
            }

            if (this.query.origin_id && this.query.destination_id) {
                let calendarDates = await this.ticsentService.getCalendar({
                    SaleChannelId: '4',
                    FromStopId: this.query.origin_id,
                    FromGroup: '',
                    ToStopId: this.query.destination_id,
                    ToGroup: ''
                });
                this.valid_dates = calendarDates;
            }
        },
        loadDestinations: async function () {
            if (this.destinations.length == 0 || this.search_paras.origin_id != this.query.origin_id) {
                try {
                    this.loadingArrivals = true;
                    let stopResult = await this.stopService.search({ page_size: 200, origin: 'stop_id:' + this.query.origin_id });

                    this.$store.commit('planner/set_search_paras', {
                        origin_id: this.query.origin_id,
                        destination_id: this.query.destination_id,
                        outward_date: this.query.outward_date
                    });
                    this.$store.commit('planner/set_destinations', stopResult.data);
                }
                finally { this.loadingArrivals = false; }
            }
        },
        loadFares: async function () {
            this.zeroProducts = false;
            if (!this.product_groups
                || this.product_groups.length == 0
                || this.search_paras.origin_id != this.query.origin_id
                || this.search_paras.destination_id != this.query.destination_id
                || this.search_paras.outward_date != this.query.outward_date
                || this.search_paras.locale != this.locale
            ) {
                try {
                    this.loadingFares = true;
                    var productResult = await this.productService.search({ origin: this.query.origin_id, destination: this.query.destination_id, date: this.query.outward_date, locale: this.locale });
                    this.$store.commit('planner/set_search_paras', {
                        origin_id: this.query.origin_id,
                        destination_id: this.query.destination_id,
                        outward_date: this.query.outward_date,
                        locale: this.locale
                    });
                    this.$store.commit('planner/set_products', productResult.data);
                    if (productResult.data.length == 0) {
                        this.zeroProducts = true;
                    }
                }
                catch {
                    this.zeroProducts = true;
                }
                finally {
                    this.loadingFares = false;
                }
            }
        },
        changeQuantity: function (product, amount, mode) {
            let ps = [];
            try {
                ps = JSON.parse(this.selected_products);
            } catch (error) {
                ps = [];
            }
            let found = false;
            if (ps.length > 0) {
                let foundProduct = ps.find(element => element.id == product.id);
                if (foundProduct) {
                    found = true;
                    if (mode == 'set') {
                        foundProduct.quantity = parseInt(amount);
                    }
                    else {
                        foundProduct.quantity += parseInt(amount);
                    }
                }
            }
            if (!found) {
                ps.push({ id: product.id, quantity: amount });
            }
            let selected = JSON.stringify(ps.filter(a => a.quantity > 0));
            this.$store.commit('planner/set_selected_products', selected);

        },
        validate: function (name) {
            return this.invalid_fields.includes(name);
        },
        searchTrips: async function () {
            let tripRequest = {
                ticket_mode: this.query.ticket_mode,
                origin_id: this.query.origin_id,
                destination_id: this.query.destination_id,
                outward_date: this.query.outward_date,
                backward_date: this.query.backward_date,
                roundtrip: this.query.roundtrip == 'true' ? true : false,
                locale: this.locale,
                products: '',
                reference: '',
            };
            let products = [].concat(...this.product_groups.map(a => a.products)).filter(a => a.quantity > 0)
                .map(p => {
                    return { id: p.id, quantity: p.quantity, data: p.data }
                });
            tripRequest.products = JSON.stringify(products);

            this.invalid_fields = [];
            if (!tripRequest.origin_id) {
                this.invalid_fields.push('origin');
            }
            if (!tripRequest.destination_id) {
                this.invalid_fields.push('destination');
            }
            if (!tripRequest.outward_date) {
                this.invalid_fields.push('outward_date');
            }
            if (tripRequest.roundtrip && (!tripRequest.backward_date)) {
                this.invalid_fields.push('backward_date');
            }
            if (products.length == 0) {
                this.invalid_fields.push('products');
            }
            if (this.invalid_fields.length == 0) {
                this.$store.commit('current_session/set_trip_search_query', tripRequest);
                this.$router.push({ path: `/${this.app_locale}/trips`, query: tripRequest })
            }
        }
    }
}
</script>
<style lang="scss" scoped></style>
